import styles from '../GameCardsPage.module.scss';
import { Popconfirm, Tag, message } from 'antd';
import Table from 'antd/es/table';
import {
  DeleteTwoTone,
  DownCircleTwoTone,
  EditTwoTone,
  EyeTwoTone,
  StopTwoTone,
} from '@ant-design/icons';
import { Link, useNavigate } from 'react-router-dom';
import { availabilityGroup, gameCardType } from '../../../components/common/EddingGameCard/config';
import { API_URL } from '../../../lib/api/index';
import useGames from '../../../lib/hooks/useGames';
import { useEffect, useState } from 'react';
import { CardTypes, IGameCard } from '../../../types/IGameCard';
import cn from 'classnames';
import { EDIT_GAME_CARD_PAGE, VIEW_GAME_CARD_PAGE } from '../../../lib';

const CardsTable = ({ type }: { type: CardTypes }) => {
  const { onGetGamesCard, gameCards, onDeleteGameCard } = useGames();
  const navigate = useNavigate();
  const [loading, setLoading] = useState<boolean>(false);
  const [currentCards, setCurrentCards] = useState<IGameCard[]>([]);

  useEffect(() => {
    const formateData = [...gameCards];
    setCurrentCards(formateData.reverse().filter(i => i.type === type));
  }, [type, gameCards]);

  const redirectTo = async (id: string, action: 'edit' | 'view') => {
    navigate(action === 'view' ? `/game_card_view?id=${id}` : `/game_card_edit?id=${id}`);
  };

  const confirmDelete = (id: string) => {
    setLoading(true);
    onDeleteGameCard(id);
    onGetGamesCard();
    setLoading(false);
    message.success('Game card deleted successfully!');
  };

  const columns: any = [
    // {
    //   title: 'id',
    //   width: 50,
    //   key: 'id',
    //   fixed: 'left',
    //   className: styles.table__cell_verticalAlign,
    //   render: (_value, _item, index) => (page - 1) * 10 + index + 1,
    // },
    {
      title: 'ID',
      width: 50,
      dataIndex: 'indexName',
      key: 'indexName',
      fixed: 'left',
      className: styles.table__cell_verticalAlign,
      sorter: (a, b) => a.indexName - b.indexName,
      render: (_eng, record) => {
        return (
          <div>
            <Tag color="#000">{record?.indexName || '...'}</Tag>
          </div>
        );
      },
    },
    {
      title: 'Description',
      width: 200,
      dataIndex: 'eng',
      key: 'eng',
      // fixed: 'left',
      className: styles.table__cell_verticalAlign,
      render: (_eng, record) => {
        return (
          <div>
            <div style={{ marginBottom: 16 }}>
              <Tag color="#00ADB5">EN:</Tag>
              {record?.eng?.description}
            </div>
            <div>
              <Tag color="#87d068">RU:</Tag>
              {record?.ru?.description}
            </div>
          </div>
        );
      },
    },
    ...(['quiz', 'musicQuiz'].includes(type)
      ? [
          {
            title: 'Answers',
            dataIndex: 'answers',
            key: 'answers',
            width: 200,
            align: 'center',
            className: styles.table__cell_verticalAlign,
            render: (_eng, record) => (
              <>
                {!!record.eng.answers?.length
                  ? record.eng.answers.map((item, idx) => (
                      <div
                        key={idx}
                        className={cn(styles.answerItem, {
                          [styles.answerItem__border]: idx !== 3,
                        })}
                      >
                        <div>
                          {item.isCorrectAnswer ? (
                            <DownCircleTwoTone twoToneColor="#7CFC00" />
                          ) : (
                            <StopTwoTone twoToneColor="#FF0000" />
                          )}
                        </div>
                        <div className={styles.answerItem__list}>
                          <div>
                            <Tag color="#00ADB5">EN:</Tag>
                            {item.value}
                          </div>
                          <div>
                            <Tag color="#87d068">RU:</Tag>
                            {record.ru.answers[idx].value}
                          </div>
                        </div>
                      </div>
                    ))
                  : '-'}
              </>
            ),
          },
        ]
      : []),
    ...(type === 'musicQuiz'
      ? [
          {
            title: 'Music quiz track name',
            width: 300,
            dataIndex: 'musicQuizTrackName',
            key: 'musicQuizTrackName',
            className: styles.table__cell_verticalAlign,
            render: musicQuizTrackName => (
              <>
                {musicQuizTrackName ? (
                  <audio controls src={`${API_URL}/storage/audio/${musicQuizTrackName}`}></audio>
                ) : (
                  '-'
                )}
              </>
            ),
          },
        ]
      : []),
    ...(type === 'virus'
      ? [
          {
            title: 'Vaccine card id',
            width: 120,
            dataIndex: 'vaccineCardId',
            key: 'vaccineCardId',
            className: styles.table__cell_verticalAlign,
            render: vaccineCardId => (
              <>
                {(
                  <div style={{ color: '#03AED2' }}>
                    <Link to={`${VIEW_GAME_CARD_PAGE}?id=${vaccineCardId}`}>{vaccineCardId}</Link>
                  </div>
                ) || '-'}
              </>
            ),
          },
        ]
      : []),
    ...(['fail', 'fortune', 'truth', 'quiz', 'dare', 'competition', 'quiz', 'musicQuiz'].includes(
      type,
    )
      ? [
          {
            title: 'Points awarded',
            width: 50,
            dataIndex: 'resultCard',
            key: 'resultCard',
            className: styles.table__cell_verticalAlign,
            sorter: (a, b) => a.resultCard - b.resultCard,
            render: resultCard => <>{resultCard || '0'}</>,
          },
        ]
      : []),
    ,
    ...(['truth', 'dare', 'quiz', 'musicQuiz'].includes(type)
      ? [
          {
            title: 'Points for refusing',
            width: 50,
            dataIndex: 'declineResultCard',
            key: 'declineResultCard',
            className: styles.table__cell_verticalAlign,
            sorter: (a, b) => a.declineResultCard - b.declineResultCard,
            render: declineResultCard => <>{declineResultCard || '0'}</>,
          },
        ]
      : []),
    // {
    //   title: 'Is virus',
    //   dataIndex: 'isVirus',
    //   key: 'isVirus',
    //   width: 90,
    //   align: 'center',
    //   className: styles.table__cell_verticalAlign,
    //   render: isVirus => (
    //     <>
    //       {isVirus ? (
    //         <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '24px' }} />
    //       ) : (
    //         <StopTwoTone twoToneColor="#cd201f" style={{ fontSize: '24px' }} />
    //       )}
    //     </>
    //   ),
    // },
    // {
    //   title: 'Is vaccine',
    //   dataIndex: 'isVaccine',
    //   key: 'isVaccine',
    //   width: 120,
    //   align: 'center',
    //   className: styles.table__cell_verticalAlign,
    //   render: isVaccine => (
    //     <>
    //       {isVaccine ? (
    //         <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: '24px' }} />
    //       ) : (
    //         <StopTwoTone twoToneColor="#cd201f" style={{ fontSize: '24px' }} />
    //       )}
    //     </>
    //   ),
    // },
    {
      title: 'Availability group',
      width: 100,
      dataIndex: 'availabilityGroup',
      key: 'availabilityGroup',
      className: styles.table__cell_verticalAlign,
      filters: availabilityGroup.eng.map(i => ({ value: i.value, text: i.label })),
      onFilter: (value: string, record: { availabilityGroup: string | string[] }) =>
        record.availabilityGroup.indexOf(value) === 0,
      render: item => {
        return (
          <div className={styles.tagList}>
            {item.map((i, index) => {
              const label = availabilityGroup.eng.find(v => v.value === i)?.label;

              if (!label) {
                return (
                  <span key={index} className={styles.tag}>
                    {i}
                  </span>
                );
              }

              if (index === 0) {
                return (
                  <span key={index} className={`${styles.tag} ${styles.firstTag}`}>
                    {label}
                  </span>
                );
              }

              return (
                <span key={index} className={styles.tag}>
                  {label}
                </span>
              );
            })}
          </div>
        );
      },
    },
    {
      title: 'Likes count',
      width: 50,
      dataIndex: 'likesCount',
      key: 'likesCount',
      className: styles.table__cell_verticalAlign,
      sorter: (a, b) => a.likesCount - b.likesCount,
    },
    {
      title: 'Action',
      key: 'operation',
      fixed: 'right',
      width: 50,
      align: 'center',
      render: answer => (
        <div className={styles.table__actions}>
          <a href={`${VIEW_GAME_CARD_PAGE}?id=${answer?._id}`}>
            <EyeTwoTone twoToneColor="#18b222" style={{ fontSize: '18px', cursor: 'pointer' }} />
          </a>

          <a href={`${EDIT_GAME_CARD_PAGE}?id=${answer?._id}`}>
            <EditTwoTone twoToneColor="#2F58CD" style={{ fontSize: '18px', cursor: 'pointer' }} />
          </a>

          <Popconfirm
            title="Are you sure you want to delete?"
            onConfirm={() => confirmDelete(answer?._id)}
            okText="Yes"
            cancelText="No"
          >
            <DeleteTwoTone twoToneColor="#D21312" style={{ fontSize: '18px' }} />
          </Popconfirm>
        </div>
      ),
    },
  ];

  return (
    <div>
      {!loading && (
        <Table
          // pagination={{
          //   onChange(current) {
          //     setPage(current);
          //   },
          // }}
          columns={columns}
          dataSource={currentCards}
          scroll={{ x: 1500 }}
          bordered
        />
      )}
    </div>
  );
};

export default CardsTable;
